import React, { useState } from "react";
import styled from "styled-components";

const HeaderContainer = styled.header`
  background-color: var(--background-white);
  padding: 1rem 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
`;

const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
`;

const LogoImg = styled.img`
  height: 50px;
  margin-right: 10px;
`;

const LogoText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ClinicName = styled.span`
  font-family: 'Libre Baskerville', serif;
  font-size: 1.5rem;
  color: var(--primary-color);
  line-height: 1.2;
  margin-right: 0.5rem;
`;

const DentalText = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 1.5rem;
  color: var(--primary-color);
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 600;
`;

const Nav = styled.nav`
  @media (max-width: 768px) {
    display: ${(props) => (props.isOpen ? "flex" : "none")};
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: var(--background-white);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 1rem 0;
  }
`;

const NavLinks = styled.ul`
  display: flex;
  list-style: none;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const NavItem = styled.li`
  margin-left: 1.5rem;
  
  @media (max-width: 768px) {
    margin: 0.5rem 0;
    text-align: center;
  }
`;

const NavLink = styled.a`
  text-decoration: none;
  color: var(--primary-color);
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  transition: color 0.3s ease;
  
  &:hover {
    color: var(--accent-color);
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--primary-color);
  cursor: pointer;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <HeaderContainer>
      <NavContainer>
        <Logo>
          <LogoImg src="/images/tooth.png" alt="Finch Dudley Dental Logo" />
          <LogoText>
            <ClinicName>Finch & Dudley</ClinicName>
            <DentalText>DENTAL</DentalText>
          </LogoText>
        </Logo>
        
        <MobileMenuButton
          onClick={toggleMenu}
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={isMenuOpen}
        >
          {isMenuOpen ? "✕" : "☰"}
        </MobileMenuButton>
        
        <Nav isOpen={isMenuOpen}>
          <NavLinks>
            <NavItem>
              <NavLink href="/#home">Home</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/#services">Services</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/#about">About Us</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/blog/">Blog</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/#contact">Contact</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="tel:4162250808" className="phone-number">416-225-0808</NavLink>
            </NavItem>
          </NavLinks>
        </Nav>
      </NavContainer>
    </HeaderContainer>
  );
};

export default Header; 